import authAction from "./actions";

const initState = {
  isLogin: localStorage.getItem("isLogin")
    ? localStorage.getItem("isLogin") === "true"
    : false,
  accessToken: localStorage.getItem("accessToken"),
  isUser: localStorage.getItem("isUser"),
  isSuperAdmin: localStorage.getItem("isSuperAdmin"),
  user: {}
};

export default function rootReducer(state = initState, action) {
  switch (action.type) {
    case authAction.LOGIN:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: action.accessToken,
        isUser: action.isUser,
        isSuperAdmin: action.isSuperAdmin,

        user: action.user
      };

    case authAction.SET_USER:
      return {
        ...state,
        user: action.user
      };

    case authAction.LOGOUT:
      return {
        ...state,
        isLogin: action.isLogin,
        accessToken: null,
        isUser: null
      };
    default:
      return state;
  }
}
